export default "__VITE_ASSET__3a1a7fb6__"